import { AttributeDefinition } from './attributeDefinition';
import { AttributeUiType } from './attributeUiType';

export class AttributeDefinitionSubFieldItem {
  public id: string;
  public subFieldDefinitionId: string;
  public subFieldDescription: string;
  public subFieldDefinition: AttributeDefinition;
  public rank: number;
  public required: boolean;
  public isHiddenOnForms: boolean;

  public static parse(
    obj: Partial<AttributeDefinitionSubFieldItem>
  ): AttributeDefinitionSubFieldItem {
    let subField = new AttributeDefinitionSubFieldItem();
    subField.id = obj.id;
    subField.subFieldDefinitionId = obj.subFieldDefinitionId;
    subField.subFieldDescription = obj.subFieldDescription;
    subField.rank = obj.rank;
    subField.required = obj.required;
    subField.isHiddenOnForms = obj.isHiddenOnForms;
    if (obj.subFieldDefinition) {
      subField.subFieldDefinition = AttributeDefinition.parse(obj.subFieldDefinition);
    }
    return subField;
  }
}

export class AttributeDefinitionSubFieldRenderItem extends AttributeDefinitionSubFieldItem {
  public name: string;
  public icon: string;
  public uiType: AttributeUiType;
  public required: boolean;
}
